import { IServiceCostEstimate } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { ServiceCostEstimateWorkItem } from 'src/app/business/service-cost-estimate/service-cost-estimate-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';
import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class ServiceCostEstimateCommandHandler extends EntityCommandHandler<IServiceCostEstimate> {
  protected workItem: IWorkItem<IServiceCostEstimate>;

  constructor(serviceCostEstimateWorkItem: ServiceCostEstimateWorkItem) {
    super();
    this.workItem = serviceCostEstimateWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'ServiceCostEstimateDto';
  }
}
